import { Tabs, TabsContent, TabsList, TabsTrigger } from "@suns/design-system";
import { EntityReportListings } from "../../../components/EntityReportListings/EntityReportListings";
// eslint-disable-next-line no-restricted-imports -- DO NOT COPY THIS LINE. See docs/lints.md.
import {
  PlayerMetadataScoreRow,
  PlayerRow,
} from "@suns/api/generated-client/apollo";
import { EntityIntelListings } from "../../../components/EntityIntelListings/EntityIntelListing";
import { PlayersStats } from "./PlayersStats";
import PlayerContracts from "./PlayerContracts";
import { PlayerAnalytics } from "./PlayerAnalytics";
import { PlayerScouting } from "./PlayerScouting";
import { useAccount } from "@/shared/hooks";
import { PlayerHealthAndPerformance } from "./PlayerHealthAndPerformance";
import { PlayerOverview } from "./PlayerOverview";
import { LeagueId } from "@suns/api";

export function PlayerInfoSection({
  player,
}: {
  player: PlayerRow & { scores: PlayerMetadataScoreRow[] };
}) {
  const {
    hasScoutAdminAccess,
    hasAdminAccess,
    hasDefaultAccess,
    hasCoachAccess,
  } = useAccount();

  const isNbaPlayer = player.currentTeams?.some(
    (team) => team.domesticLeagueId == LeagueId.NBA
  );

  const tabOptions = [
    {
      title: "Overview",
      component: (
        <PlayerOverview
          playerId={player.id}
          metadata={player.metadata?.[0]}
          nbaId={player.nbaId ?? undefined}
          isNbaPlayer={isNbaPlayer}
        />
      ),
      show: hasDefaultAccess,
    },
    {
      title: "Analytics",
      component: <PlayerAnalytics player={player} />,
      show: hasScoutAdminAccess || hasCoachAccess,
    },
    {
      title: "Scouting",
      component: <PlayerScouting player={player} />,
      show: hasScoutAdminAccess,
    },
    {
      title: "Health & Performance",
      component: <PlayerHealthAndPerformance player={player} />,
      show: hasScoutAdminAccess || hasCoachAccess,
    },
    { title: "Stats", component: <PlayersStats player={player} />, show: true },
    {
      title: "Contracts",
      component: <PlayerContracts player={player} />,
      show: hasAdminAccess && isNbaPlayer,
    },
    {
      title: "Reports",
      component: <EntityReportListings />,
      show: hasScoutAdminAccess,
    },
    {
      title: "Intel",
      component: <EntityIntelListings />,
      show: hasScoutAdminAccess,
    },
  ].filter((tab) => tab.show);

  return (
    <Tabs defaultValue={tabOptions[0]?.title} className="w-full">
      <TabsList className="mb-4 max-sm:w-full" wrap>
        {tabOptions.map(
          (tab) =>
            tab.show && (
              <TabsTrigger
                key={tab.title}
                value={tab.title}
                className="px-2 max-sm:text-xs md:px-3"
              >
                {tab.title}
              </TabsTrigger>
            )
        )}
      </TabsList>
      {tabOptions.map((tab) => (
        <TabsContent key={tab.title} value={tab.title}>
          {tab.component}
        </TabsContent>
      ))}
    </Tabs>
  );
}
